exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cardnew[data-v-82df2892] {\n  background-color: #e9ebee;\n  min-height: 92vh;\n  height: 100% !important;\n}\n", ""]);

// exports
